import React from "react";
import { Column, Container, Icon, Row } from "../components";
import { Spacer } from "./spacer";
import { Text } from "./text";
import { useParams } from "react-router-dom";
import {
  useOrderQuery,
  OrderableType,
  BookingType as BookingTypeNew,
  useSpaceV2Query,
  useLocationV2Query,
} from "./api";
import { useGetPartnerOffering } from "../data/api";
import { getMainOrderItem } from "./order";
import { TemplateOfferingConfirmOrderBase } from "./template_offering_confirm_order_base";
import { formatDateRange } from "./format_date_range";
import { parseDay } from "./day_utils";
import { Divider } from "./divider";
import { getMaxCapacity } from "../data";
import { useI18n } from "../lib/i18n/i18n_provider";
import { PartnerConfig } from "./partner_config";

interface TemplateOfferingConfirmOrderDayOfficeParams {
  orderID: string;
  offeringID: string;
  spaceID: string;
}

interface TemplateOfferingConfirmOrderDayOfficeProps {
  showTalkWithUsPrompt?: boolean;
  partnerConfig: PartnerConfig;
}

export function TemplateOfferingConfirmOrderDayOffice(
  props: TemplateOfferingConfirmOrderDayOfficeProps
) {
  const { partnerConfig, showTalkWithUsPrompt } = props;
  const pageParams = useParams<TemplateOfferingConfirmOrderDayOfficeParams>();
  const order = useOrderQuery(pageParams.orderID);
  const orderItem = getMainOrderItem(order);
  const { fbt, locale } = useI18n();
  if (
    !orderItem ||
    orderItem.type !== OrderableType.Booking ||
    orderItem.details.type !== BookingTypeNew.Daily
  ) {
    throw new Error("Invalid order");
  }
  const partnerOfferingID = pageParams.offeringID;
  const partnerOffering = useGetPartnerOffering(partnerOfferingID);
  const space = useSpaceV2Query(orderItem.details.spaceID);
  const location = useLocationV2Query(space.locationID);

  return (
    <TemplateOfferingConfirmOrderBase
      showTalkWithUsPrompt={showTalkWithUsPrompt}
      numberOfInvites={
        getMaxCapacity(space) > 1 ? getMaxCapacity(space) : undefined
      }
      partnerOfferingID={partnerOfferingID}
      partnerOffering={partnerOffering}
      offeringName={`${space.productType?.name} ${orderItem.details.physicalSpace?.name}`}
      partnerConfig={partnerConfig}
      order={order}
      location={location}
      space={space}
      mobileCheckoutBox={
        <Container>
          <Container paddingVertical={16}>
            <Row alignItems="center">
              <Icon name="map-pin" />
              <Spacer size={8} direction="horizontal" />
              <Column flex={1}>
                <Text>{location.city}</Text>
                <Text size="sm">{location.streetAddress}</Text>
              </Column>
            </Row>
          </Container>
          <Divider />
          <Container paddingVertical={16}>
            <Row>
              <Row flex={1}>
                <Icon name="calendar" />
                <Spacer size={8} direction="horizontal" />
                <Text>
                  {formatDateRange(
                    {
                      start: parseDay(orderItem.details.startDate),
                      end: parseDay(orderItem.details.endDate),
                    },
                    fbt,
                    locale
                  )}
                </Text>
              </Row>
              <Spacer size={16} direction="horizontal" />
              <Row flex={1}>
                <Icon name="box" />
                <Spacer size={8} direction="horizontal" />
                <Text>Quantity: {orderItem.quantity}</Text>
              </Row>
            </Row>
          </Container>
          <Divider />
        </Container>
      }
      desktopCheckoutBox={
        <Container>
          <Container paddingHorizontal={16} height={64}>
            <Row expanded alignItems="center" flex={1}>
              <Icon name="map-pin" />
              <Spacer size={8} direction="horizontal" />
              <Column flex={1}>
                <Text>{location.city}</Text>
                <Text size="sm">{location.streetAddress}</Text>
              </Column>
            </Row>
          </Container>
          <Divider />
          <Container paddingHorizontal={16} height={64}>
            <Row expanded alignItems="center" flex={1}>
              <Icon name="calendar" />
              <Spacer size={8} direction="horizontal" />
              <Text>
                {formatDateRange(
                  {
                    start: parseDay(orderItem.details.startDate),
                    end: parseDay(orderItem.details.endDate),
                  },
                  fbt,
                  locale
                )}
              </Text>
            </Row>
          </Container>
        </Container>
      }
    />
  );
}
